<script setup lang="ts">
import { cartItemCount, cartSlideoverOpen } from '~/composables/useCart';
import AppCartSlideover from '~/components/AppCartSlideover.vue';

const isNative = useIsNativePlatform();

const overlay = useOverlay();
const cartSlideover = overlay.create(AppCartSlideover);

watch(cartSlideoverOpen, async (open) => {
  if (open) {
    await cartSlideover.open();
    cartSlideoverOpen.value = false;
  } else {
    cartSlideover.close();
  }
});
</script>
<template>
  <div v-if="!isNative" class="flex items-center">
    <UChip v-if="cartItemCount > 0" :text="cartItemCount" size="2xl" color="primary" position="top-left">
      <UButton icon="heroicons:shopping-bag" variant="link" size="xl" class="m-0 p-0" @click="cartSlideoverOpen = true" />
    </UChip>
  </div>
</template>
